import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";

export interface ICouponserviceBomResponseData {
  bom_id: string;
  bom_name: string;
}
export interface ICouponserviceBomResponse {
  status: boolean;
  message: string;
  data: ICouponserviceBomResponseData[];
}

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

AxiosCurlirize(axios, () => {});

export const useCouponBomListAPICoupon = () => {
  const [bomlist, setBomlist] = useState<ICouponserviceBomResponseData[]>([]);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (vms_subcategory_id: string, vms_category_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(
            `${COUPON_SERVICE_APIS?.COUPON_BOM_LIST_POST?.baseURL}`,
            {
              vms_category_id: vms_category_id,
              vms_subcategory_id: vms_subcategory_id,
            },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<ICouponserviceBomResponse>) => {
            if (res.data.status) {
              setBomlist(res.data.data);
              return { status: true, message: null };
              //
            } else {
              setBomlist([]);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              setBomlist([]);
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              setBomlist([]);
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              setBomlist([]);
              // toast.error("Server error 500");
            }
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
        setBomlist([]);
      }
    },
    [dispatch],
  );
  return { execute, bomlist };
};
